import React from 'react';
import { CreateBySong } from '../CreateBySong';
import { MainContext } from '../../context';
import { CreateByGenre } from '../CreateByGenre';
import { CreateByArtist } from '../CreateByArtist';

export const SearchForm = () => {
  //Get what user is filtering filtering by from context
  const { filterType } = React.useContext(MainContext);

  if (filterType === 'song') return <CreateBySong />;
  if (filterType === 'genre') return <CreateByGenre />;
  if (filterType === 'artist') return <CreateByArtist />;
  return <CreateBySong />;
};
